import { provider } from '@/provider.js'

const state = {
  boards: [
    {
      id: 1,
      title: 'Support',
      buckets: [
        { id: 30, name: 'Support', caseTypeId: 7, caseTypeName: 'Tickets', color: '#1976d2' },
        { id: 3645, name: 'V3', caseTypeId: 80, caseTypeName: 'Tickets', color: '#1976d2' },
        { id: 3657, name: 'Cigna', caseTypeId: 80, caseTypeName: 'Tickets', color: '#388e3c' },
        { id: 3658, name: 'ScotGov', caseTypeId: 80, caseTypeName: 'Tickets', color: '#f57c00' },
        { id: 3659, name: 'Winchurch', caseTypeId: 80, caseTypeName: 'Tickets', color: '#7b1fa2' },
        { id: 3478, name: 'U-Drive', caseTypeId: 80, caseTypeName: 'Tickets', color: '#d32f2f' },
        { id: 3661, name: 'Internal', caseTypeId: 80, caseTypeName: 'Tickets', color: '#5d4037' },
        { id: 3662, name: 'UltimateEar', caseTypeId: 80, caseTypeName: 'Tickets', color: '#0277bd' },
      ],
    },
    {
      id: 2,
      title: 'V3 Features',
      buckets: [
        { id: 3700, name: 'Agent', color: '#FF6B6B', caseTypeId: 311 },
        { id: 3701, name: 'Login', color: '#4ECDC4', caseTypeId: 311 },
        { id: 3702, name: 'Users', color: '#45B7D1', caseTypeId: 311 },
        { id: 3703, name: 'Bookmarks', color: '#96CEB4', caseTypeId: 311 },
        { id: 3704, name: 'Timeline', color: '#FF8A80', caseTypeId: 311 }
      ]
    }
  ],
  currentBoard: null,
  columnOrder: [
    'Not Started',
    'Started',
    'Under Review',
    'Ready for UAT',
    'Ready for Release',
    'Complete'
  ]
}

const mutations = {
  setCurrentBoard(state, board) {
    state.currentBoard = board
  },
  updateBoards(state, boards) {
    state.boards = boards
  }
}

const actions = {
  getBoardById({ commit, state }, boardId) {
    const board = state.boards.find(b => b.id === parseInt(boardId))
    if (board) {
      commit('setCurrentBoard', board)
      return board
    }
    return null
  }
}

const getters = {
  getBoardById: (state) => (boardId) => {
    return state.boards.find(b => b.id === parseInt(boardId))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
